import React from 'react';
import { SubpageBanner, Cta1 } from '../components';
import { useTranslation } from 'react-i18next';

const NordexAcademy = () => {
    const { t } = useTranslation();

    return (
        <div>
            <SubpageBanner
                title={t('academy.bannerTitle')}
                page={t('academy.bannerPage')}
                textTitle={t('academy.bannerTextTitle')}
                text={t('academy.bannerText')}
                path="/nordex-academy"
            />
            <div className="academy-page">
                <div className="container py-5">
                    {/* Giriş Metni */}
                    <div className="academy-intro-section mb-5">
                        {/* <p className="academy-intro-text">{t('academy.intro.p1')}</p> */}
                        <p className="academy-intro-text">{t('academy.intro.p2')}</p>
                        <p className="academy-intro-text">{t('academy.intro.p3')}</p>
                    </div>

                    {/* Nordex Eğitim */}
                    <div className="academy-section mb-5">
                        <h2 className="academy-section-title">{t('academy.education.title')}</h2>
                        <p className="academy-section-text">{t('academy.education.desc')}</p>
                    </div>

                    {/* Nordex Akademi'nin Amacı */}
                    <div className="academy-section mb-5">
                        <h2 className="academy-section-title">{t('academy.purpose.title')}</h2>
                        <p className="academy-section-text mb-3">{t('academy.purpose.desc')}</p>
                        <ul className="academy-list">
                            {t('academy.purpose.items', { returnObjects: true }).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                        {t('academy.purpose.footer') && (
                            <p className="academy-section-footer">{t('academy.purpose.footer')}</p>
                        )}
                    </div>

                    {/* Güven ve Uyumluluk Perspektifi */}
                    <div className="academy-section mb-5">
                        <h2 className="academy-section-title">{t('academy.compliance.title')}</h2>
                        <p className="academy-section-text mb-3">{t('academy.compliance.desc')}</p>
                        <ul className="academy-list">
                            {t('academy.compliance.items', { returnObjects: true }).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                        {t('academy.compliance.footer') && (
                            <p className="academy-section-footer">{t('academy.compliance.footer')}</p>
                        )}
                    </div>
                </div>

                <Cta1
                    title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
                />
            </div>
        </div>
    );
};

export default NordexAcademy;
